import { render, staticRenderFns } from "./CelestialObjects.vue?vue&type=template&id=13e79bc6&"
import script from "./CelestialObjects.vue?vue&type=script&lang=js&"
export * from "./CelestialObjects.vue?vue&type=script&lang=js&"
import style0 from "./CelestialObjects.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports